import { colors } from 'styles/colors';

type Download1IconProps = {
  color?: string;
  size?: number;
}

export const Download1Icon = ({ color = colors.icon['primary-base'], size }: Download1IconProps): JSX.Element => (
  <svg width={size ?? '14'} height={size ?? '15'} viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.25 9.25V9.95C12.25 10.9301 12.25 11.4201 12.0593 11.7945C11.8915 12.1238 11.6238 12.3915 11.2945 12.5593C10.9201 12.75 10.4301 12.75 9.45 12.75H4.55C3.56991 12.75 3.07986 12.75 2.70552 12.5593C2.37623 12.3915 2.10852 12.1238 1.94074 11.7945C1.75 11.4201 1.75 10.9301 1.75 9.95V9.25M9.91667 6.33333L7 9.25M7 9.25L4.08333 6.33333M7 9.25V2.25" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
